/** A collapsible section on the warehouse detail page. */
import { ChevronDown } from 'lucide-react';
import type { ReactNode } from 'react';

export default function WarehouseSectionCard({
  title,
  expanded,
  onToggle,
  children,
}: {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  children: ReactNode;
}) {
  return (
    <div className="bg-white dark:bg-[#1a1f1c] border rounded-lg">
      <button
        onClick={onToggle}
        className="w-full px-6 py-4 flex items-center justify-between hover:bg-stone-50 dark:hover:bg-[#242d28] transition"
      >
        <h3 className="font-semibold text-bark-900 dark:text-stone-100">{title}</h3>
        <ChevronDown
          size={18}
          className={`text-stone-400 transition ${expanded ? '' : '-rotate-90'}`}
        />
      </button>
      {expanded && <div className="px-6 py-4 border-t">{children}</div>}
    </div>
  );
}
